import {ClassComponent, Vnode} from 'mithril';
import withAttr from 'flarum/common/utils/withAttr';
import FormGroup from './FormGroup';

interface DiscreetInputAttrs {
    value: string
    editable?: boolean
    placeholder: string
    title: string
    validationErrors: any
    onchange: (value: string) => void
}

export default class DiscreetInput implements ClassComponent<DiscreetInputAttrs> {
    view(vnode: Vnode<DiscreetInputAttrs, this>) {
        if (vnode.attrs.editable) {
            const returnVnode = m('input.FormulaireDiscreetInput', {
                value: vnode.attrs.value,
                onchange: withAttr('value', (value: string) => {
                    vnode.attrs.onchange(value);
                }),
                placeholder: vnode.attrs.placeholder,
                title: vnode.attrs.title,
            });

            // Wrap into the form-group to re-use the error message logic
            // Only do it when there's actually an error as this breaks the layout
            if (vnode.attrs.validationErrors) {
                return m(FormGroup, {
                    validationErrors: vnode.attrs.validationErrors,
                }, returnVnode) as Vnode<any>;
            }

            return returnVnode;
        }

        return m('span.FormulaireDiscreetInput', {
            title: vnode.attrs.title,
        }, vnode.attrs.value || vnode.attrs.placeholder);
    }
}
